import { createSlice } from '@reduxjs/toolkit'

export const gradeScaleUI = createSlice({
  name: 'gradeScaleUI',
  initialState: {
    activeFilters: [] as string[],
    tableFilters: {
      search: '',
    },
  },
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    clearAllFilters: (state) => {
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  clearAllFilters,
} = gradeScaleUI.actions

export default gradeScaleUI.reducer
